import type { BaseMessage } from '@hover/embed/post-message-api';

export const isMessageOfType = <T extends BaseMessage>(
  message: MessageEvent<BaseMessage>,
  type: T['type'],
): message is MessageEvent<T> =>
  message.data?.type === type &&
  !!message.data?.payload &&
  type in message.data?.payload;
